import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { deviceTypeTableIcon } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { getUrlPathForDeviceTypeName } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import {
  batteryStatusTooltip,
  deviceHealthTooltip,
  lastHeardTooltip
} from 'src/app/shared/components/listing-table/listing-page.consts';
import { BubbleColumnComponent } from 'src/app/shared/components/listing-table/components/bubble-column.component';
import { StatusDotColumnComponent } from 'src/app/shared/components/listing-table/components/status-dot-column.component';
import { LocationColumnComponent } from 'src/app/shared/components/table-columns/location-column.component';
import { DeviceType } from '../../components/devices.models';

export const createDcuColumns = (): TableColumn[] => [
  {
    field: 'deviceId',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.COMM_DEVICE_ID,
    width: 400,
    sortable: false,
    link: {
      getLink: (dataItem): string =>
        `devices/${getUrlPathForDeviceTypeName(dataItem['deviceType'] as DeviceType)}/${dataItem['deviceUID']}`
    }
  },
  {
    field: 'deviceTypeName',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.DEVICE_TYPE,
    width: 200,
    sortable: true,
    icon: deviceTypeTableIcon
  },
  {
    field: 'modelName',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.MODEL_NAME,
    width: 300,
    sortable: true
  },
  {
    field: 'status',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.STATUS,
    width: 200,
    sortable: false,
    cmp: StatusDotColumnComponent,
    textColor: '#070C0F'
  },
  {
    field: 'dcuCommunicationStatus',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.COMMUNICATION_STATUS,
    width: 200,
    sortable: false
  },
  {
    field: 'deviceStatusValue',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.HEALTH,
    width: 200,
    sortable: true,
    cmp: BubbleColumnComponent,
    tooltip: deviceHealthTooltip
  },
  {
    field: 'lastHeard',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.LAST_HEARD,
    width: 200,
    sortable: true,
    tooltip: lastHeardTooltip
  },
  {
    field: 'mainBoardFw',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.MAIN_BOARD_FW_VERSION,
    width: 100,
    sortable: false
  },
  {
    field: 'powerSupplyBoardFw',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.POWER_SUPPLY_BOARD_FW_VERSION,
    width: 100,
    sortable: false
  },
  {
    field: 'slot1Fw',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.SLOT1_BOARD_FW_VERSION,
    width: 100,
    sortable: false
  },
  {
    field: 'slot2Fw',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.SLOT2_BOARD_FW_VERSION,
    width: 100,
    sortable: false
  },
  {
    field: 'slot3Fw',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.SLOT3_BOARD_FW_VERSION,
    width: 100,
    sortable: false
  },
  {
    field: 'batteryStatus',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.BATTERY_STATUS,
    width: 200,
    sortable: false,
    cmp: BubbleColumnComponent,
    tooltip: batteryStatusTooltip
  },
  {
    field: 'deviceNameCustom',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.DEVICE_NAME,
    width: 200,
    sortable: false
  },
  {
    field: 'deviceLocationCustom',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.DCU_LOCATION,
    width: 200,
    sortable: false
  },
  {
    field: 'location',
    title: TranslateRegistry.get.DCUS_BASE_STATIONS.VIEW_TABLE.LOCATION,
    width: 200,
    sortable: false,
    cmp: LocationColumnComponent
  }
];
